var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "grid-view",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.title,
        width: "650px",
        "close-on-click-modal": false,
        "destroy-on-close": true,
        "append-to-body": ""
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        },
        close: _vm.onCancel
      }
    },
    [
      _c(
        "div",
        { staticClass: "tabs-container" },
        [
          _c(
            "el-tabs",
            {
              attrs: { "active-name": _vm.activeTabName },
              on: { "tab-click": _vm.handleClick }
            },
            [
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("CargoMsg.Cargo_ApplicationForm"),
                    name: "applicationForm"
                  }
                },
                [
                  _c(
                    "el-form",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        inline: true,
                        "label-width": "75px",
                        "label-position": "left",
                        disabled: _vm.action === "look"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "row"
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { "padding-top": "10px" } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("CargoMsg.Cargo_TaxRate")
                                  }
                                },
                                [
                                  _c("el-input-number", {
                                    staticStyle: { width: "200px" },
                                    attrs: {
                                      "controls-position": "right",
                                      max: 999.0,
                                      min: 0.0,
                                      precision: 2
                                    },
                                    model: {
                                      value: _vm.pay.taxRate,
                                      callback: function($$v) {
                                        _vm.$set(_vm.pay, "taxRate", $$v)
                                      },
                                      expression: "pay.taxRate"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "Invoice.invoice_invoiceCategory"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "200px" },
                                      attrs: { clearable: "" },
                                      model: {
                                        value: _vm.pay.invoiceType,
                                        callback: function($$v) {
                                          _vm.$set(_vm.pay, "invoiceType", $$v)
                                        },
                                        expression: "pay.invoiceType"
                                      }
                                    },
                                    _vm._l(_vm.invoiceMakeTypes, function(
                                      item,
                                      index
                                    ) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.chineseName,
                                          value: item.code
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("CargoMsg.Cargo_Priority")
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "200px" },
                                      attrs: { clearable: "" },
                                      model: {
                                        value: _vm.pay.priority,
                                        callback: function($$v) {
                                          _vm.$set(_vm.pay, "priority", $$v)
                                        },
                                        expression: "pay.priority"
                                      }
                                    },
                                    _vm._l(_vm.priorityTypes, function(
                                      item,
                                      index
                                    ) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.chineseName,
                                          value: item.code
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "dense-radio-group",
                                  attrs: { label: " " }
                                },
                                [
                                  _c(
                                    "el-checkbox-group",
                                    {
                                      staticStyle: { "margin-left": "10px" },
                                      attrs: { max: 1 },
                                      on: { change: _vm.prepayChange },
                                      model: {
                                        value: _vm.prepayList,
                                        callback: function($$v) {
                                          _vm.prepayList = $$v
                                        },
                                        expression: "prepayList"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-checkbox",
                                        { attrs: { label: 1 } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("CargoMsg.Cargo_Prepaid")
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-checkbox",
                                        { attrs: { label: 2 } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_Collection"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "el-form-item-wrapper" },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("Payment.remarks"),
                                    "label-width": "100px"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "240px" },
                                    attrs: { type: "textarea", rows: 6 },
                                    model: {
                                      value: _vm.pay.remark,
                                      callback: function($$v) {
                                        _vm.$set(_vm.pay, "remark", $$v)
                                      },
                                      expression: "pay.remark"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      "add" !== _vm.action
                        ? _c(
                            "div",
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_ReceiveMethod"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "200px" },
                                      model: {
                                        value: _vm.pay.receiveType,
                                        callback: function($$v) {
                                          _vm.$set(_vm.pay, "receiveType", $$v)
                                        },
                                        expression: "pay.receiveType"
                                      }
                                    },
                                    _vm._l(_vm.receiveTypes, function(
                                      item,
                                      index
                                    ) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: _vm.$store.getters.isZh
                                            ? item.chineseName
                                            : item.englishName,
                                          value: item.code
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_AccountToBeCredited"
                                    ),
                                    "label-width": "95px"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "240px" },
                                    model: {
                                      value: _vm.pay.receiveAccount,
                                      callback: function($$v) {
                                        _vm.$set(_vm.pay, "receiveAccount", $$v)
                                      },
                                      expression: "pay.receiveAccount"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_ReceivingBank"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "200px" },
                                      on: { change: _vm.recipientBankChange },
                                      model: {
                                        value: _vm.recipientBankUuid,
                                        callback: function($$v) {
                                          _vm.recipientBankUuid = $$v
                                        },
                                        expression: "recipientBankUuid"
                                      }
                                    },
                                    _vm._l(_vm.receivingBanks, function(
                                      item,
                                      index
                                    ) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label:
                                            item.currency + "-" + item.bank,
                                          value: item.uuid
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_BankConnectionNo2"
                                    ),
                                    "label-width": "95px"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "240px" },
                                    model: {
                                      value: _vm.pay.swiftCode,
                                      callback: function($$v) {
                                        _vm.$set(_vm.pay, "swiftCode", $$v)
                                      },
                                      expression: "pay.swiftCode"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  ),
                  "add" !== _vm.action
                    ? _c(
                        "div",
                        [
                          _c("cargo-ag-grid", {
                            staticStyle: {
                              width: "100%",
                              height: "100%",
                              "flex-grow": "1"
                            },
                            attrs: {
                              "config-module": "190805",
                              "grid-params": _vm.gridParams,
                              "grid-options": _vm.gridOptions,
                              "column-defs": _vm.columnDefs,
                              "row-data": _vm.rowData
                            },
                            on: {
                              "update:gridParams": function($event) {
                                _vm.gridParams = $event
                              },
                              "update:grid-params": function($event) {
                                _vm.gridParams = $event
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm.pay.uuid
                ? _c(
                    "el-tab-pane",
                    {
                      staticStyle: { height: "509px" },
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_FileHistory"),
                        name: "fileHistory",
                        lazy: true
                      }
                    },
                    [
                      _c("file-history", {
                        attrs: {
                          uuid: _vm.pay.uuid,
                          state: _vm.pay.apState,
                          "module-name": "billPayment",
                          "input-by": _vm.$store.getters.userId,
                          "grid-height": "460px"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c("hr"),
      _c(
        "div",
        {
          staticStyle: {
            "margin-bottom": "10px",
            display: "flex",
            float: "right"
          }
        },
        [
          ["add", "edit"].includes(_vm.action)
            ? _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
              )
            : _vm._e(),
          _c("el-button", { on: { click: _vm.onCancel } }, [
            _vm._v(_vm._s(_vm.$t("Pricing.Cancel")))
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }